import { AuthError } from './errors.ts'
import { claimsOf } from './jwt.ts'
import type { AuthKernel } from './kernel.ts'

/** Only tokens minted by `InitiateAuth` carry it, and the self-service operations need it. */
const ADMIN_SCOPE = 'aws.cognito.signin.user.admin'

function grantsAdminScope(accessToken: string): boolean {
  const claims = claimsOf(accessToken)
  // An unreadable token is not a proof of absence: let Cognito be the judge.
  if (claims === null) return true
  return (claims.scope ?? '').split(' ').includes(ADMIN_SCOPE)
}

/** The token for an operation the pool only accepts under `ADMIN_SCOPE`. Pre-checked because
 *  Cognito answers a missing scope and a wrong password alike — see the README. */
export async function adminScopedAccessToken(kernel: AuthKernel, subject: string): Promise<string> {
  const accessToken = await kernel.accessToken()
  if (accessToken === null) {
    throw new AuthError('no_refresh_token', `There is no session to ${subject}`)
  }
  if (!grantsAdminScope(accessToken)) {
    throw new AuthError('scope_insufficient', `The access token is missing ${ADMIN_SCOPE}`)
  }
  return accessToken
}
